var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileMigration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 7.062v22.68A2.259 2.259 0 0121.741 32H2.26A2.259 2.259 0 010 29.741V2.26A2.259 2.259 0 012.259 0h14.565L24 7.062z",
    fill: "#2B2BA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.5a.5.5 0 000 1v-1zm8.354.854a.5.5 0 000-.708l-3.182-3.182a.5.5 0 10-.707.708L35.293 16l-2.828 2.828a.5.5 0 10.707.707l3.182-3.181zM28 16.5h8v-1h-8v1z",
    fill: "#7D8894"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 7.062v22.68A2.259 2.259 0 0161.741 32H42.26A2.259 2.259 0 0140 29.741V2.26A2.259 2.259 0 0142.259 0h14.565L64 7.062z",
    fill: "#7427EF"
  })));
}
export default SvgFileMigration;